(() => {
  const THUMBNAIL_IMAGE_WIDTH_PX = 71;
  const THUMBNAIL_MARGIN_RIGHT_PX = 8;
  const THUMBNAIL_IMAGE_TOTAL_WIDTH_PX = THUMBNAIL_IMAGE_WIDTH_PX + THUMBNAIL_MARGIN_RIGHT_PX;

  const thumbnailImage = ({ imgUrl, altText }) => {
    const img = document.createElement('img');
    img.className = 'order-trade-in-lookup-result__thumbnail-image';
    img.style.width = `${THUMBNAIL_IMAGE_WIDTH_PX}px`;
    img.style.marginRight = `${THUMBNAIL_MARGIN_RIGHT_PX}px`;
    img.loading = 'lazy';
    IMAGE_UTILS.setElementImage({
      imageElement: img,
      imgOptions: { width: THUMBNAIL_IMAGE_WIDTH_PX },
      imgUrl,
      altText,
    });

    return img;
  };

  const getPlusNMoreText = (count) => {
    const { thumbnailsMoreItemsText } = ORDER_TRADE_IN_LOOKUP_RESULT_CONFIG;
    return thumbnailsMoreItemsText.replace('[count]', count);
  };

  class OrderTradeInLookupResultThumbnails extends HTMLElement {
    constructor() {
      super();
      this._images = [];

      this._root = document.createElement('div');
      this._root.className = 'order-trade-in-lookup-result__thumbnails-container';

      this._plusNMore = document.createElement('span');
      this._plusNMore.className = 'order-trade-in-lookup-result__more-thumbnails hidden';
      this._root.appendChild(this._plusNMore);

      // We'll populate this after this element is connected to the document
      this._plusNMoreWidthPx = null;
    }

    connectedCallback() {
      this.replaceChildren(this._root);
      this._samplePlusNMoreWidth();
      this._renderContents();
    }

    /**
     * Get the images for this element.
     * @returns {{ imgUrl: string; altText?: string | null; }[]}
     */
    get images() {
      return this._images;
    }

    /**
     * Set the images for this element.
     * @param {{ imgUrl: string; altText?: string | null; }[]} images
     */
    set images(images) {
      this._images = images;
      if (this.isConnected) {
        // Make sure to re-render ALL images
        this._root.replaceChildren(this._plusNMore);
        this._renderContents();
      }
    }

    /**
     * Update the displayed images after the browser window has been resized.
     */
    handleResizeEvent() {
      this._renderContents();
    }

    _samplePlusNMoreWidth() {
      this._plusNMore.style.visibility = 'hidden';
      this._plusNMore.classList.remove('hidden');
      this._plusNMore.textContent = getPlusNMoreText(99);
      this._plusNMoreWidthPx = this._plusNMore.clientWidth;
      this._plusNMore.classList.add('hidden');
      this._plusNMore.style.removeProperty('visibility');
    }

    _renderContents() {
      const fullAvailableWidth = this._root.clientWidth;
      const maxImagesToDisplay = Math.floor(fullAvailableWidth / THUMBNAIL_IMAGE_TOTAL_WIDTH_PX);
      const shouldShowPlusNMore = this._images.length > maxImagesToDisplay;
      const availableWidthAfterPlusNMore = Math.max(fullAvailableWidth - this._plusNMoreWidthPx, 0);
      const numImagesToDisplay = shouldShowPlusNMore ?
        Math.floor(availableWidthAfterPlusNMore / THUMBNAIL_IMAGE_TOTAL_WIDTH_PX) :
        this._images.length;

      const imagesAlreadyRendered = Array.from(this._root.children).filter(
        child => child.tagName === 'IMG',
      );

      // Add images as needed to fill available width
      this._images.slice(imagesAlreadyRendered.length, numImagesToDisplay).forEach((image) => {
        this._root.insertBefore(thumbnailImage(image), this._plusNMore);
      });

      // Remove images as needed to stay within available width
      imagesAlreadyRendered.slice(numImagesToDisplay).forEach((node) => {
        this._root.removeChild(node);
      });

      // Show/hide "+ N more" as appropriate and set the displayed count
      if (shouldShowPlusNMore) {
        this._plusNMore.textContent = getPlusNMoreText(this._images.length - numImagesToDisplay);
        this._plusNMore.classList.remove('hidden');
      } else {
        this._plusNMore.classList.add('hidden');
      }
    }
  }

  if (!customElements.get('order-trade-in-lookup-result-thumbnails')) {
    customElements.define(
      'order-trade-in-lookup-result-thumbnails',
      OrderTradeInLookupResultThumbnails,
    );
  }
})();
